import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';

const StyledTaskAddDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
    height: clamp(0px, ${props => props.theme.layout(504)}, 86vh);
    max-height: clamp(0px, ${props => props.theme.layout(504)}, 86vh);
  }
  
  .TaskAddDialog {
    &-content {
      height: 1px;
      padding: 0;
      overflow: visible;
      position: relative;
    }
  }
  
  ${ComponentStyles}
`;

StyledTaskAddDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledTaskAddDialog;
